enum Environment {
  Development = "development",
  Test = "test",
  ProductionOrSandbox = "production_or_sandbox",
}

export {Environment};
